import { createSelector } from '@reduxjs/toolkit';
import { getThemeByName } from 'theme/base';

export const themeSelector = state => state.theme;

export const getGlobalTheme = createSelector(themeSelector, themeOptions => {
  return themeOptions; // consists of theme and color scheme
});

export const getSelectedTheme = createSelector(getGlobalTheme, themeMode => {
  /**
   * TODO: Once theme options are set in the security company object, we can read the theme key to check which them is available to use
   */

  return getThemeByName(themeMode.mode);
});
